import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@/services/auth'
import Home from '@/views/Home'
import About from '@/views/About'
import Contacts from '@/views/Contacts'
import Legal from '@/views/Legal'
import ChangeFeed from '@/views/ChangeFeed'
import Login from '@/views/Login'
import UserOnboarding from '@/views/UserOnboarding'
import EditProfile from '@/views/EditProfile'
import ProfileSetup from '@/views/ProfileSetup'

import ListEvents from '@/views/ListEvents'
import EventDetails from '@/views/EventDetails'
import ListEngagements from '@/views/ListEngagements'
import EngagementDetails from '@/views/EngagementDetails'

import SearchProjects from '@/views/SearchProjects'
// import MyImpact from '@/views/MyImpact'
import Error404 from '@/views/Error404'

import MakerOnboarding from '@/views/MakerOnboarding'
import PayoutSetup from '@/views/PayoutSetup'
// import MakerPayoutOverview from '@/views/MakerPayoutOverview'

import ForgotPassword from '@/views/auth/ForgotPassword'
import ForgotPasswordSuccess from '@/views/auth/ForgotPasswordSuccess'
import PasswordResetConfirm from '@/views/auth/PasswordResetConfirm'

import NewProjectGoals from '@/views/NewProjectGoals'
import GoalList from '@/views/GoalList'
import GoalDonation from '@/views/GoalDonation'
// import PaymentInformation from '@/views/PaymentInformation'
import FundingHistory from '@/views/FundingHistory'
import PaymentSetup from '@/views/PaymentSetup'
import PaymentSignUp from '@/views/PaymentSignUp'
import EditGoal from '@/views/EditGoal'
import NewProject from '@/views/NewProject'
import EditProject from '@/views/EditProject'
import NewUpdate from '@/views/NewUpdate'
import NewPhoto from '@/views/NewPhoto'
import Project from '@/views/Project'
import Profile from '@/views/Profile'

import MakerProjectFeed from '@/views/MakerProjectFeed'
import Questions from '@/views/Questions'

import AssignmentsOverview from '@/views/AssignmentsOverview'
import AssignmentsDetail from '@/views/AssignmentsDetail'
import AssignmentsNeedsFurtherReview from '@/views/AssignmentsNeedsFurtherReview'

import StaffMakerOverview from '@/views/StaffMakerOverview'
import StaffActivatorOverview from '@/views/StaffActivatorOverview'
// import StaffPaymentsOverview from '@/views/StaffPaymentsOverview'
// import StaffPaymentsDetail from '@/views/StaffPaymentsDetail'
// import StaffPayoutsOverview from '@/views/StaffPayoutsOverview'
// import StaffPayoutsDetail from '@/views/StaffPayoutsDetail'
import StaffReports from '@/views/StaffReports'

// import TestPage from '@/views/TestPage'

Vue.use(Router)

/** Google Analytics: Add this to a Vue route to customize how page views are sent to GA... */
// meta: {
//   analytics: {
//     pageviewTemplate() {
//       return {
//         title: 'Create Project Goals',
//         page: '/new-goals/:projectId',
//       }
//     }
//   }
// }
/** Otherwise, default 'page' property sent to GA will be the full route path & the default 'title' will be 'ChangeFunder'.
 * 'page' is  set for most of these routes b/c we don't want to track appended params (like '/new-goals/f34kg234...' or '/search-projects?=10')
 */

const scrollBehavior = function(to, from, savedPosition) {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else if (to.hash) {
    // scroll to anchor by returning the selector
    return { selector: to.hash }
  } else {
    return { x: 0, y: 0 }
  }
}

export default new Router({
  mode: 'history',

  scrollBehavior,

  routes: [
    {
      path: '/',
      component: Home,
      name: 'Home',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Home',
              page: '/',
            }
          },
        },
      },
    },
    {
      path: '/about-us',
      component: About,
      name: 'About',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'About',
              page: '/about-us',
            }
          },
        },
      },
    },
    {
      path: '/contact-us',
      component: Contacts,
      name: 'Contacts',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Contacts',
              page: '/contact-us',
            }
          },
        },
      },
    },
    {
      path: '/legal',
      component: Legal,
      name: 'Legal',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Legal',
              page: '/legal',
            }
          },
        },
      },
    },
    {
      path: '/feed',
      component: ChangeFeed,
      name: 'ChangeFeed',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Change Feed',
              page: '/feed',
            }
          },
        },
      },
    },
    // {
    //   path: '/test',
    //   component: TestPage,
    //   name: 'TestPage',
    // },
    {
      path: '/login',
      component: Login,
      name: 'Login',
      beforeEnter: Auth.requireNoAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Login',
              page: '/login',
            }
          },
        },
      },
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      beforeEnter: Auth.requireNoAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Forgot Password',
              page: '/forgot-password',
            }
          },
        },
      },
    },
    {
      path: '/forgot-password-success',
      name: 'ForgotPasswordSuccess',
      component: ForgotPasswordSuccess,
      beforeEnter: Auth.requireNoAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Forgot Password Success',
              page: '/forgot-password-success',
            }
          },
        },
      },
    },
    {
      path: '/password/reset/confirm/:uid/:token',
      name: 'PasswordResetConfirm',
      component: PasswordResetConfirm,
      beforeEnter: Auth.requireNoAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Forgot Reset Confirm',
              page: '/password/reset/confirm',
            }
          },
        },
      },
    },
    {
      path: '/user-onboarding',
      component: UserOnboarding,
      name: 'UserOnboarding',
      beforeEnter: Auth.requireNoAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'User Onboarding',
              page: '/user-onboarding',
            }
          },
        },
      },
    },
    {
      path: '/profile-setup',
      component: ProfileSetup,
      name: 'ProfileSetup',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Profile Setup',
              page: '/profile-setup',
            }
          },
        },
      },
    },
    {
      path: '/edit-profile',
      component: EditProfile,
      name: 'EditProfile',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Edit Profile',
              page: '/edit-profile',
            }
          },
        },
      },
    },
    {
      path: '/events',
      component: ListEvents,
      name: 'ListEvents',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'ListEvents',
              page: '/events',
            }
          },
        },
      },
    },
    {
      path: '/events/:eventId',
      component: EventDetails,
      name: 'EventDetails',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'EventDetails',
              page: '/events/:eventId',
            }
          },
        },
      },
    },
    {
      path: '/engagements',
      component: ListEngagements,
      name: 'ListEngagements',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'ListEngagements',
              page: '/engagements',
            }
          },
        },
      },
    },
    {
      path: '/engagements/:engagementId',
      component: EngagementDetails,
      name: 'EngagementDetails',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'EngagementDetails',
              page: '/engagements/:engagementId',
            }
          },
        },
      },
    },
    {
      path: '/search-projects/:buttonId?',
      component: SearchProjects,
      name: 'SearchProjects',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Search Projects',
              page: '/search-projects',
            }
          },
        },
      },
    },
    // {
    //   path: '/my-impact',
    //   component: MyImpact,
    //   name: 'MyImpact',
    //   beforeEnter: Auth.requireAuth,
    //   meta: {
    //     analytics: {
    //       pageviewTemplate() {
    //         return {
    //           title: 'My Impact',
    //           page: '/my-impact',
    //         }
    //       },
    //     },
    //   },
    // },
    {
      path: '/maker-onboarding',
      component: MakerOnboarding,
      name: 'MakerOnboarding',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Maker Onboarding',
              page: '/maker-onboarding',
            }
          },
        },
      },
    },
    {
      path: '/payout-setup',
      component: PayoutSetup,
      name: 'PayoutSetup',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Payout Setup',
              page: '/payout-setup',
            }
          },
        },
      },
    },
    {
      path: '/new-goals/:projectId',
      component: NewProjectGoals,
      name: 'NewProjectGoals',
      props: true,
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'New Project Goals',
              page: '/new-goals/:projectId',
            }
          },
        },
      },
    },
    {
      path: '/goal-list/:projectId',
      component: GoalList,
      name: 'GoalList',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Goal List',
              page: '/goal-list',
            }
          },
        },
      },
    },
    {
      path: '/donate/:projectId/:goalId',
      component: GoalDonation,
      name: 'GoalDonation',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Goal Donation',
              page: '/donate/:projectId/:goalId',
            }
          },
        },
      },
    },
    {
      path: '/payment-setup/:amount/:goalId',
      component: PaymentSetup,
      name: 'PaymentSetup',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Payment Setup',
              page: '/payment-setup',
            }
          },
        },
      },
    },
    {
      path: '/payment-signup/:amount/:goalId',
      component: PaymentSignUp,
      name: 'PaymentSignUp',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Payment SignUp',
              page: '/payment-signup/:amount/:goalId',
            }
          },
        },
      },
    },
    {
      // TODO: Should turn this into props
      path: '/modify-goals/:projectId/:goalId?',
      component: EditGoal,
      name: 'EditGoal',
      props: true,
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Edit Goal',
              page: '/modify-goals/:projectId/:goalId',
            }
          },
        },
      },
    },
    {
      path: '/new-update/:projectId',
      component: NewUpdate,
      name: 'NewUpdate',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'New Update',
              page: '/new-update/:projectId',
            }
          },
        },
      },
    },
    {
      path: '/new-photo/:projectId',
      component: NewPhoto,
      name: 'NewPhoto',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'New Photo',
              page: '/new-photo/:projectId',
            }
          },
        },
      },
    },
    {
      path: '/questions/:projectId',
      component: Questions,
      name: 'Questions',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Project Questions',
              page: '/questions/:projectId',
            }
          },
        },
      },
    },
    {
      path: '/new-project',
      component: NewProject,
      name: 'NewProject',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'New Project',
              page: '/new-project',
            }
          },
        },
      },
    },
    {
      path: '/edit-project/:projectId',
      component: EditProject,
      name: 'EditProject',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Edit Project',
              page: '/edit-project/:projectId',
            }
          },
        },
      },
    },
    {
      path: '/projects/:projectId',
      component: Project,
      name: 'Project',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Project',
              page: '/projects/:projectId',
            }
          },
        },
      },
    },
    {
      path: '/profile/:userId',
      component: Profile,
      name: 'Profile',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'User Profile',
              page: '/profile/:userId',
            }
          },
        },
      },
    },
    {
      path: '/my-project-feed',
      component: MakerProjectFeed,
      name: 'MakerProjectFeed',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Maker Project Feed',
              page: '/my-project-feed',
            }
          },
        },
      },
    },
    // {
    //   path: '/my-payouts',
    //   component: MakerPayoutOverview,
    //   name: 'MakerPayoutOverview',
    //   beforeEnter: Auth.requireAuth,
    //   meta: {
    //     analytics: {
    //       pageviewTemplate() {
    //         return {
    //           title: 'Maker Payout Overview',
    //           page: '/my-payouts',
    //         }
    //       },
    //     },
    //   },
    // },
    {
      path: '/my-assignments',
      component: AssignmentsOverview,
      name: 'AssignmentsOverview',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: "Activator's Assignments Overview",
              page: '/my-assignments',
            }
          },
        },
      },
    },
    // {
    //   path: '/payment-information',
    //   component: PaymentInformation,
    //   name: 'PaymentInformation',
    //   beforeEnter: Auth.requireAuth,
    //   meta: {
    //     analytics: {
    //       pageviewTemplate() {
    //         return {
    //           title: 'Payment Information',
    //           page: '/payment-information',
    //         }
    //       },
    //     },
    //   },
    // },
    {
      path: '/funding-history',
      component: FundingHistory,
      name: 'FundingHistory',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Funding History',
              page: '/funding-history',
            }
          },
        },
      },
    },
    {
      path: '/my-assignments/:userId',
      component: AssignmentsDetail,
      name: 'AssignmentsDetail',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: "Activator's Assignments Detail",
              page: '/my-assignments/:userId',
            }
          },
        },
      },
    },
    {
      path: '/my-assignments/needs-review/:projectId',
      component: AssignmentsNeedsFurtherReview,
      name: 'AssignmentsNeedsFurtherReview',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: "Activator's Assignments that Need Further Review",
              page: '/my-assignments/needs-review/:projectId',
            }
          },
        },
      },
    },
    {
      path: '/staff/activators/',
      component: StaffActivatorOverview,
      name: 'StaffActivatorOverview',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: "Staff's Activator Overview",
              page: '/staff/activators',
            }
          },
        },
      },
    },
    {
      path: '/staff/makers/',
      component: StaffMakerOverview,
      name: 'StaffMakerOverview',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: "Staff's Makers Overview",
              page: '/staff/makers',
            }
          },
        },
      },
    },
    // {
    //   path: '/staff/payments/',
    //   component: StaffPaymentsOverview,
    //   name: 'StaffPaymentsOverview',
    //   beforeEnter: Auth.requireAuth,
    //   meta: {
    //     analytics: {
    //       pageviewTemplate() {
    //         return {
    //           title: "Staff's Payments Overview",
    //           page: '/staff/payments',
    //         }
    //       },
    //     },
    //   },
    // },
    // {
    //   path: '/staff/payments/:paymentId',
    //   component: StaffPaymentsDetail,
    //   name: 'StaffPaymentsDetail',
    //   beforeEnter: Auth.requireAuth,
    //   meta: {
    //     analytics: {
    //       pageviewTemplate() {
    //         return {
    //           title: "Staff's Payments Detail",
    //           page: '/staff/payments/:paymentId',
    //         }
    //       },
    //     },
    //   },
    // },
    // {
    //   path: '/staff/payouts/',
    //   component: StaffPayoutsOverview,
    //   name: 'StaffPayoutsOverview',
    //   beforeEnter: Auth.requireAuth,
    //   meta: {
    //     analytics: {
    //       pageviewTemplate() {
    //         return {
    //           title: "Staff's Payouts Overview",
    //           page: '/staff/payouts',
    //         }
    //       },
    //     },
    //   },
    // },
    // {
    //   path: '/staff/payouts/:payoutId',
    //   component: StaffPayoutsDetail,
    //   name: 'StaffPayoutsDetail',
    //   beforeEnter: Auth.requireAuth,
    //   meta: {
    //     analytics: {
    //       pageviewTemplate() {
    //         return {
    //           title: "Staff's Payouts Detail",
    //           page: '/staff/payouts/:payoutId',
    //         }
    //       },
    //     },
    //   },
    // },
    {
      path: '/staff/reports/',
      component: StaffReports,
      name: 'StaffReports',
      beforeEnter: Auth.requireAuth,
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: "Staff's Reports",
              page: '/staff/reports',
            }
          },
        },
      },
    },
    {
      path: '/404',
      component: Error404,
      name: 'Error404',
      meta: {
        analytics: {
          pageviewTemplate() {
            return {
              title: 'Page Not Found',
              page: '/404',
            }
          },
        },
      },
    },
    { path: '*', redirect: '404' },
  ],
})
